export const LOAD_TIMELINE_LEAD = 'LOAD_TIMELINE_LEAD';

export const loadLead = lead => ({
  type: LOAD_TIMELINE_LEAD,
  lead
});
